var _path, _path2, _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13172_115352",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13172_115352)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    width: 33.6,
    height: 24,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13172_115352",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: 0,
    width: 34,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2,
    width: 33.6,
    height: 24,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13172_115352)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6 0H-2V1.6H31.6V0ZM31.6 3.2H-2V4.8H31.6V3.2ZM-2 6.4H31.6V8H-2V6.4ZM31.6 9.6H-2V11.2H31.6V9.6ZM-2 12.8H31.6V14.4H-2V12.8ZM31.6 16H-2V17.6H31.6V16ZM-2 19.2H31.6V20.8H-2V19.2ZM31.6 22.4H-2V24H31.6V22.4Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2,
    width: 14.4,
    height: 11.2,
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13172_115352)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19961 2.39961C1.19961 2.84144 0.841437 3.19961 0.399609 3.19961C-0.0422184 3.19961 -0.400391 2.84144 -0.400391 2.39961C-0.400391 1.95778 -0.0422184 1.59961 0.399609 1.59961C0.841437 1.59961 1.19961 1.95778 1.19961 2.39961ZM4.39961 2.39961C4.39961 2.84144 4.04144 3.19961 3.59961 3.19961C3.15778 3.19961 2.79961 2.84144 2.79961 2.39961C2.79961 1.95778 3.15778 1.59961 3.59961 1.59961C4.04144 1.59961 4.39961 1.95778 4.39961 2.39961ZM6.79961 3.19961C7.24144 3.19961 7.59961 2.84144 7.59961 2.39961C7.59961 1.95778 7.24144 1.59961 6.79961 1.59961C6.35778 1.59961 5.99961 1.95778 5.99961 2.39961C5.99961 2.84144 6.35778 3.19961 6.79961 3.19961ZM10.7996 2.39961C10.7996 2.84144 10.4414 3.19961 9.99961 3.19961C9.55778 3.19961 9.19961 2.84144 9.19961 2.39961C9.19961 1.95778 9.55778 1.59961 9.99961 1.59961C10.4414 1.59961 10.7996 1.95778 10.7996 2.39961ZM1.99961 4.79961C2.44144 4.79961 2.79961 4.44144 2.79961 3.99961C2.79961 3.55778 2.44144 3.19961 1.99961 3.19961C1.55778 3.19961 1.19961 3.55778 1.19961 3.99961C1.19961 4.44144 1.55778 4.79961 1.99961 4.79961ZM5.99961 3.99961C5.99961 4.44144 5.64144 4.79961 5.19961 4.79961C4.75778 4.79961 4.39961 4.44144 4.39961 3.99961C4.39961 3.55778 4.75778 3.19961 5.19961 3.19961C5.64144 3.19961 5.99961 3.55778 5.99961 3.99961ZM8.39961 4.79961C8.84144 4.79961 9.19961 4.44144 9.19961 3.99961C9.19961 3.55778 8.84144 3.19961 8.39961 3.19961C7.95778 3.19961 7.59961 3.55778 7.59961 3.99961C7.59961 4.44144 7.95778 4.79961 8.39961 4.79961ZM10.7996 5.59961C10.7996 6.04144 10.4414 6.39961 9.99961 6.39961C9.55778 6.39961 9.19961 6.04144 9.19961 5.59961C9.19961 5.15778 9.55778 4.79961 9.99961 4.79961C10.4414 4.79961 10.7996 5.15778 10.7996 5.59961ZM6.79961 6.39961C7.24144 6.39961 7.59961 6.04144 7.59961 5.59961C7.59961 5.15778 7.24144 4.79961 6.79961 4.79961C6.35778 4.79961 5.99961 5.15778 5.99961 5.59961C5.99961 6.04144 6.35778 6.39961 6.79961 6.39961ZM4.39961 5.59961C4.39961 6.04144 4.04144 6.39961 3.59961 6.39961C3.15778 6.39961 2.79961 6.04144 2.79961 5.59961C2.79961 5.15778 3.15778 4.79961 3.59961 4.79961C4.04144 4.79961 4.39961 5.15778 4.39961 5.59961ZM0.399609 6.39961C0.841437 6.39961 1.19961 6.04144 1.19961 5.59961C1.19961 5.15778 0.841437 4.79961 0.399609 4.79961C-0.0422185 4.79961 -0.400391 5.15778 -0.400391 5.59961C-0.400391 6.04144 -0.0422185 6.39961 0.399609 6.39961ZM2.79961 7.19961C2.79961 7.64144 2.44144 7.99961 1.99961 7.99961C1.55778 7.99961 1.19961 7.64144 1.19961 7.19961C1.19961 6.75778 1.55778 6.39961 1.99961 6.39961C2.44144 6.39961 2.79961 6.75778 2.79961 7.19961ZM5.19961 7.99961C5.64144 7.99961 5.99961 7.64144 5.99961 7.19961C5.99961 6.75778 5.64144 6.39961 5.19961 6.39961C4.75778 6.39961 4.39961 6.75778 4.39961 7.19961C4.39961 7.64144 4.75778 7.99961 5.19961 7.99961ZM9.19961 7.19961C9.19961 7.64144 8.84144 7.99961 8.39961 7.99961C7.95778 7.99961 7.59961 7.64144 7.59961 7.19961C7.59961 6.75778 7.95778 6.39961 8.39961 6.39961C8.84144 6.39961 9.19961 6.75778 9.19961 7.19961ZM9.99961 9.59961C10.4414 9.59961 10.7996 9.24144 10.7996 8.79961C10.7996 8.35778 10.4414 7.99961 9.99961 7.99961C9.55778 7.99961 9.19961 8.35778 9.19961 8.79961C9.19961 9.24144 9.55778 9.59961 9.99961 9.59961ZM7.59961 8.79961C7.59961 9.24144 7.24144 9.59961 6.79961 9.59961C6.35778 9.59961 5.99961 9.24144 5.99961 8.79961C5.99961 8.35778 6.35778 7.99961 6.79961 7.99961C7.24144 7.99961 7.59961 8.35778 7.59961 8.79961ZM3.59961 9.59961C4.04144 9.59961 4.39961 9.24144 4.39961 8.79961C4.39961 8.35778 4.04144 7.99961 3.59961 7.99961C3.15778 7.99961 2.79961 8.35778 2.79961 8.79961C2.79961 9.24144 3.15778 9.59961 3.59961 9.59961ZM1.19961 8.79961C1.19961 9.24144 0.841437 9.59961 0.399609 9.59961C-0.0422185 9.59961 -0.400391 9.24144 -0.400391 8.79961C-0.400391 8.35778 -0.0422185 7.99961 0.399609 7.99961C0.841437 7.99961 1.19961 8.35778 1.19961 8.79961Z",
    fill: "url(#paint0_linear_13172_115352)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13172_115352",
    x: -0.400391,
    y: 1.59961,
    width: 11.2002,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13172_115352"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13172_115352",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13172_115352",
    x1: -0.400391,
    y1: 1.59961,
    x2: -0.400391,
    y2: 9.59961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.8c7283664bdd0a10dcf0e590de153038.svg";
export { ForwardRef as ReactComponent };